<template>
<div class="chapter">
<div class="inner_page">
<p class="copy-t1">Coach, Run, Win</p>
<p class="copy-t2">A Comprehensive Guide to Coaching High School Cross Country, Running Fast, and Winning Championships</p>
<p class="copy">© 2022 Ken Sayles</p>
<p class="copy">All rights reserved. No portion of this book may be reproduced, stored in a retrieval system, or transmitted in any form or by any means—electronic, mechanical, photocopy, recording, scanning, or other—except for brief quotations in critical reviews or articles, without the prior written permission of the publisher.</p>
<p class="copy">Published in New York, New York, by Morgan James Publishing. Morgan James is a trademark of Morgan James, LLC. <a href="http://www.MorganJamesPublishing.com" target="_blank">www.MorganJamesPublishing.com</a></p>
<p class="copy">Proudly distributed by Ingram Publisher Services.</p>
<table>
<colgroup>
<col width="45%"/>
<col width="55%"/>
</colgroup>
<tbody><tr>
<td><p class="copylm"> </p></td>
<td><p class="copylm"> </p></td>
</tr>
<tr>
<td>
<p class="copyl"><img alt="image" src="images/logo1.png"/></p>
</td>
<td>
<p class="copym">ISBN 9781631956133 paperback</p>
<p class="copyn">ISBN 9781631956140 ebook</p>
<p class="copyn">Library of Congress Control Number:</p>
<p class="copyn">2021937298</p>
<p class="copym"><span class="bold">Cover &amp; Interior Design by:</span></p>
<p class="copyn">Chris Treccani</p>
<p class="copyn"><a href="http://www.3dogcreative.net" target="_blank">www.3dogcreative.net</a></p>
</td>
</tr>
</tbody></table>
<p class="imagel"><img alt="image" src="images/logo.png"/></p>
<p class="copyc">Morgan James is a proud partner of Habitat for Humanity Peninsula and Greater Williamsburg. Partners in building since 2006.</p>
<p class="copyc">Get involved today! Visit <a href="http://MorganJamesPublishing.com/giving-back" target="_blank">MorganJamesPublishing.com/giving-back</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copy.vue?0f41f531